import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpService } from '../../services/http.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzFormModule } from 'ng-zorro-antd/form';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { Router, RouterLink } from '@angular/router';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { DataService } from '../../services/data.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { distinctUntilChanged, pairwise, switchMap } from 'rxjs/operators';
import { NzCheckboxComponent } from 'ng-zorro-antd/checkbox';
import { subYears } from 'date-fns';
import { UserAccountDTO, UserRegisterDataDTO } from '../../classes/user-account.dto';
import { StorageService } from '../../services/storage.service';
import { CommonModule } from '@angular/common';
import { GtmService } from '../../services/gtm.service';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NonFocusableStepsDirective } from '../../directives/non-focusable-steps.directive';
import { FiscalCodeService } from '../../services/fiscal-code.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { NzRadioGroupAccessibilityDirective } from '../../directives/nz-radio-group-accessibility.directive';

@Component({
    selector: 'app-login-update-profile',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NzGridModule,
        TranslateModule,
        NzFlexModule,
        NzCheckboxComponent,
        NzTypographyModule,
        NzDividerModule,
        NzIconModule,
        NzImageModule,
        NzFormModule,
        NzInputModule,
        NzSpaceModule,
        NzStepsModule,
        NonFocusableStepsDirective,
        NzSelectModule,
        FormsModule,
        NzRadioModule,
        NzRadioGroupAccessibilityDirective,
        RouterLink,
        NzButtonModule
    ],
    templateUrl: './login-update-profile.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    styleUrl: './login-update-profile.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class LoginUpdateProfileComponent implements OnInit {
  validateForm!: FormGroup;
  countries: any;
  districts: any;
  districtsTaxcode: any;
  cities: any;
  citiesTaxcode: any;
  isPhonePortrait: boolean = false;
  current: number = 0;
  subscriptions: Array<Subscription> = [];
  companyId: string = '';
  datepicker = {
    control: subYears(new Date(), 100),
    endControl: new Date(),
  };
  userDataToBeUpdated!: UserAccountDTO;
  readonlyFields: Record<string, boolean> = {
    name: false,
    surname: false,
    email: false,
    fiscalCode: false,
    phoneNumber: false,
    nation: false,
    city: false,
    province: false,
    cap: false,
    address: false,
    houseNumber: false,
  };
  birthCity: any;
  birthCountry: any;
  birthDistrict: any;
  origin?: string;

  constructor(
    private fb: FormBuilder,
    private http: HttpService,
    private responsive: BreakpointObserver,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private storage: StorageService,
    private router: Router,
    private gtmService: GtmService,
    private fiscalCodeService: FiscalCodeService,
    private toastr: ToastrService, 
    private translate: TranslateService,
    private authService: AuthService
  ) {
    this.initForm();
  }

  ngOnInit() {
    const nav = this.router.getCurrentNavigation();
    const fromNav =  nav?.extras?.state?.['from'];
    this.origin = fromNav || localStorage.getItem('updateProfileFrom');
    this.cdr.detectChanges();
    this.responsive.observe(Breakpoints.HandsetPortrait).subscribe((result) => {
      this.isPhonePortrait = false;
      if (result.matches) {
        this.isPhonePortrait = true;
      }
    });
    this.dataService.companyId$.subscribe((companyId) => {
      this.companyId = companyId!;
    });
    this.validateForm!.valueChanges.subscribe((res) => this.cdr.detectChanges());
    this.toggleFormTaxcodeSection();
    console.log(this.current, "current")
  }

  private initForm() {
    this.validateForm = this.fb.group({
      calculateTaxcode: [false],
      phoneNumber: this.fb.control('', [Validators.required, Validators.pattern(/^(?:\+?[0-9]{8,})$/)]),
      nation: this.fb.control('', [Validators.required]),
      houseNumber: this.fb.control(''),
      province: this.fb.control('', [Validators.required]),
      cap: this.fb.control('', [Validators.required]),
      city: this.fb.control('', [Validators.required]),
      address: this.fb.control('', [Validators.required]),
      email: this.fb.control('', [Validators.required, Validators.email]),
      fiscalCode: this.fb.control('', [Validators.required]),
      name: this.fb.control('', [Validators.required]),
      surname: this.fb.control('', [Validators.required]),
      radio1: this.fb.control('', [Validators.required]),
      radio2: this.fb.control('', [Validators.required]),
      radio3: this.fb.control('', [Validators.required]),
      radio4: this.fb.control('', [Validators.required]),
      radioTerms: this.fb.control('', [Validators.required]),
    });
    this.userDataToBeUpdated = JSON.parse(this.storage.getItem('userDataToBeUpdated')!) as UserAccountDTO;
    if (this.userDataToBeUpdated) {
      this.updateUser();
    }
  }

  public fillDistricts(): void {
    if (this.validateForm.get('nation')?.value!) {
      this.http.getDistrict(this.validateForm.get('nation')?.value!).subscribe({
        next: (v) => {
          this.validateForm.get('district')?.value ? this.validateForm.get('province')?.patchValue('') : '';
          this.validateForm.get('city')?.value ? this.validateForm.get('city')?.patchValue('') : '';
          this.districts = v;
        },
        error: (e) => {
          this.validateForm.get('nation')?.patchValue('');
          this.validateForm.get('province')?.value ? this.validateForm.get('province')?.patchValue('') : '';
          this.validateForm.get('city')?.value ? this.validateForm.get('city')?.patchValue('') : '';
          this.districts = [];
          this.cities = [];
        },
      });
    }
  }

  public fillCities(): void {
    if (this.validateForm.get('province')?.value!) {
      this.http.getProvince(this.validateForm.get('province')?.value!).subscribe({
        next: (v) => {
          this.cities = v;
          this.validateForm.get('city')?.value ? this.validateForm.get('city')?.patchValue('') : '';
        },
        error: (e) => {
          this.validateForm.get('province')?.patchValue('');
          this.validateForm.get('city')?.value ? this.validateForm.get('city')?.patchValue('') : '';
          this.cities = [];
        },
      });
    }
  }

  public next(index: any): void {
    switch (index) {
      case 0: {
        if (this.validateForm.get('name')?.valid && this.validateForm.get('surname')?.valid) {
          if (this.userDataToBeUpdated) {
            this.userDataToBeUpdated.name = this.validateForm.value.name;
            this.userDataToBeUpdated.surname = this.validateForm.value.surname;
          }
          this.current += 1;
          this.gtmService.pushUpdateUserEvent('step1_name');
          this.gtmService.pushVirtualPage('Name', '/step1_name');
        }
        break;
      }
      case 1: {
        const fiscalCodeControl = this.validateForm.get('fiscalCode');
        if (fiscalCodeControl?.valid) {
          if (this.userDataToBeUpdated) {
            this.userDataToBeUpdated.taxId = fiscalCodeControl.value;
          }
          const fiscalCode = fiscalCodeControl.value!;
          if (!this.fiscalCodeService.isFiscalCodeValid(fiscalCode)) {
            this.toastr.error(this.translate.instant('toastr.error.invalidFiscalCode'));
            return;
          }
          let datiCF;
          try {
            datiCF = this.fiscalCodeService.extractData(fiscalCode);
          } catch (err) {
            fiscalCodeControl.markAsDirty();
            fiscalCodeControl.updateValueAndValidity({ onlySelf: true });
            this.toastr.error(this.translate.instant('toastr.error.invalidFiscalCode'));
            return;
          }
          this.birthCity = datiCF.birthplace || '';
          this.current += 1;
          this.gtmService.pushUpdateUserEvent('step2_fiscal_code');
          this.gtmService.pushVirtualPage('Fiscal code', '/step2_fiscal_code');
        } else {
          fiscalCodeControl?.markAsDirty();
          fiscalCodeControl?.updateValueAndValidity({ onlySelf: true });
        }
        break;
      }
      case 2: {
        if (this.validateForm.get('email')?.valid && this.validateForm.get('phoneNumber')?.valid) {
          if (this.userDataToBeUpdated) {
            this.userDataToBeUpdated.email = this.validateForm.value.email;
            this.userDataToBeUpdated.phoneNumber = this.validateForm.value.phoneNumber;
          }
          this.http.getCountries().subscribe((res: any) => {
            if (res) {
              this.countries = res;
              this.current += 1;
              this.gtmService.pushUpdateUserEvent('step3_contact_details');
              this.gtmService.pushVirtualPage('Contact Details', '/step3_contact_details');
            }
          });
        } else {
          this.validateForm.get('email')?.markAsDirty();
          this.validateForm.get('email')?.updateValueAndValidity({ onlySelf: true });
          this.validateForm.get('fiscalCode')?.markAsDirty();
          this.validateForm.get('fiscalCode')?.updateValueAndValidity({ onlySelf: true });
        }
        break;
      }
      case 3: {
        if (
          ((this.validateForm.get('nation')?.valid && this.validateForm.get('province')?.valid && this.validateForm.get('city')?.valid) ||
            (this.validateForm.getRawValue()?.nation && this.validateForm.getRawValue()?.province && this.validateForm.getRawValue()?.city)) &&
          this.validateForm.get('cap')?.valid &&
          this.validateForm.get('address')?.valid &&
          this.validateForm.get('houseNumber')?.valid
        ) {
          if (this.userDataToBeUpdated) {
            this.userDataToBeUpdated.country = this.validateForm.value.nation;
            this.userDataToBeUpdated.district = this.validateForm.value.province;
            this.userDataToBeUpdated.city = this.validateForm.value.city;
            this.userDataToBeUpdated.address = this.validateForm.value.addess;
            this.userDataToBeUpdated.postalCode = this.validateForm.value.cap;
          }
          this.current += 1;
          this.gtmService.pushUpdateUserEvent('step4_residence');
          this.gtmService.pushVirtualPage('Residence', '/step4_residence')
        } else {
          this.validateForm.get('nation')?.markAsDirty();
          this.validateForm.get('nation')?.updateValueAndValidity({ onlySelf: true });
          this.validateForm.get('province')?.markAsDirty();
          this.validateForm.get('province')?.updateValueAndValidity({ onlySelf: true });
          this.validateForm.get('city')?.markAsDirty();
          this.validateForm.get('city')?.updateValueAndValidity({ onlySelf: true });
          this.validateForm.get('cap')?.markAsDirty();
          this.validateForm.get('cap')?.updateValueAndValidity({ onlySelf: true });
          this.validateForm.get('address')?.markAsDirty();
          this.validateForm.get('address')?.updateValueAndValidity({ onlySelf: true });
          this.validateForm.get('houseNumber')?.markAsDirty();
          this.validateForm.get('houseNumber')?.updateValueAndValidity({ onlySelf: true });
        }
        break;
      }
      case 4: {
        if (this.validateForm.get('radio1')?.valid && this.validateForm.get('radio2')?.valid && this.validateForm.get('radio3')?.valid && this.validateForm.get('radio4')?.valid) {
          let userData = new UserRegisterDataDTO();
          userData.address = this.validateForm.get('address')?.value!;
          userData.taxId = this.validateForm.get('fiscalCode')?.value!;
          userData.name = this.validateForm.get('name')?.value!;
          userData.surname = this.validateForm.get('surname')?.value!;
          userData.postalCode = this.validateForm.get('cap')?.value!;
          userData.city = this.cities.find((res: any) => res.code === this.validateForm.get('city')?.value!);
          userData.email = this.validateForm.get('email')?.value!;
          userData.birthDate = this.validateForm.get('birthDate')?.value!;
          userData.birthCity = this.birthCity;
          userData.birthCountry = this.birthCountry;
          userData.birthDistrict = this.birthDistrict;
          userData.gender = this.userDataToBeUpdated.gender;
          userData.phone = this.validateForm.get('phoneNumber')?.value!;
          userData.country = this.countries.find((res: any) => res.code === this.validateForm.get('nation')?.value!);
          userData.district = this.districts.find((res: any) => res.code === this.validateForm.get('district')?.value!);
          userData.mobilePhone = this.validateForm.get('phoneNumber')?.value!;
          userData.userName = this.validateForm.get('email')?.value!;
          userData.privacy_eai_iccs = this.validateForm.get('radio1')?.value! == 'true' ? true : false;
          userData.privacy_eai_profile = this.validateForm.get('radio2')?.value! == 'true' ? true : false;
          userData.privacy_vai_iccs = this.validateForm.get('radio3')?.value! == 'true' ? true : false;
          userData.privacy_vai_profile = this.validateForm.get('radio4')?.value! == 'true' ? true : false;
          userData.individualId = this.userDataToBeUpdated.individualId;
          userData.companyId = this.companyId!;
          userData.updateFromSSO = false;
          this.http.updateAccount(userData).subscribe((res) => {
            if (res) {
              if (this.origin === "\"activation\"") {
                this.validateForm.get('radioTerms')?.setValue(true)
                localStorage.setItem('userData', JSON.stringify(this.userDataToBeUpdated));
                localStorage.removeItem('userDataToBeUpdated');
                this.router.navigate(['/personal-area']);
                return;
              } else {
                this.current += 1;
                this.gtmService.pushUpdateUserEvent('step5_privacy');
                this.gtmService.pushVirtualPage('Privacy', '/step5_privacy');
                this.gtmService.pushUpdateUserEvent('update_user_data_success');
              }
            }
          });
          break;
        } else {
          this.validateForm.get('radio1')?.markAsDirty();
          this.validateForm.get('radio1')?.updateValueAndValidity({ onlySelf: true });
          this.validateForm.get('radio2')?.markAsDirty();
          this.validateForm.get('radio2')?.updateValueAndValidity({ onlySelf: true });
          this.validateForm.get('radio3')?.markAsDirty();
          this.validateForm.get('radio3')?.updateValueAndValidity({ onlySelf: true });
          this.validateForm.get('radio4')?.markAsDirty();
          this.validateForm.get('radio4')?.updateValueAndValidity({ onlySelf: true });
        }
        break;
      }
      case 5: {
        if (this.validateForm.get('radioTerms')?.valid) {
          localStorage.setItem('userData', JSON.stringify(this.userDataToBeUpdated));
          localStorage.removeItem('userDataToBeUpdated');
          this.authService.isAuthenticatedSubject.next(true);
          this.router.navigate(['/personal-area']);
        } else {
          this.validateForm.get('radioTerms')?.markAsDirty();
          this.validateForm.get('radioTerms')?.updateValueAndValidity({ onlySelf: true });
        }
        break;
      }
      default: {
        this.current += 1;
      }
    }
  }

  public back(): void {
    this.current -= 1;
  }

  public goToLink() {
    window.open('https://assets.europassistance.it/Documents/informativa-privacy-MyClinic.pdf', '_blank', 'noopener');
  }

  private calculateTaxcode(): void {
    const valuesForm = this.validateForm?.value;
    if (!valuesForm || !valuesForm.name || !valuesForm.surname || !valuesForm.taxcodeSection) {
      return;
    }
    try {
      const computedTaxcode = this.fiscalCodeService.generateFiscalCode({
        firstName: valuesForm.name,
        lastName: valuesForm.surname,
        gender: valuesForm.taxcodeSection.gender,
        birthDate: valuesForm.taxcodeSection.birthdate,
        birthCity: valuesForm.taxcodeSection.birthCity.text as string,
        birthProvince: valuesForm.taxcodeSection.birthDistricts.value as string,
      });
      this.validateForm!.get('taxcode')?.patchValue(computedTaxcode, { emitEvent: false });
      this.cdr.detectChanges();
    } catch (err) {
      console.error('Error calculating fiscal code', err);
      this.toastr.error(this.translate.instant('toastr.error.invalidFiscalCode'));
    }
  }

  private toggleFormTaxcodeSection(): void {
    this.subscriptions.push(
      this.validateForm!.get('calculateTaxcode')!.valueChanges.subscribe((value: boolean) => {
        if (value) {
          this.validateForm?.addControl(
            'taxcodeSection',
            this.fb.group({
              gender: ['', Validators.required],
              birthDate: ['', Validators.required],
              birthDistrict: ['', Validators.required],
              birthCity: ['', Validators.required],
            })
          );
          this.fillDistrictsTaxCode();
          this.listenerOnForm();
        } else {
          this.validateForm?.removeControl('taxcodeSection');
        }
        this.cdr.detectChanges();
      })
    );
  }
  private listenerOnForm(): void {
    this.subscriptions.push(
      this.validateForm!.valueChanges.pipe(distinctUntilChanged(), pairwise()).subscribe(([previous, current]) => {
        this.cdr.detectChanges();
        if (previous.taxcode !== current.taxcode) {
          return;
        }
        if (this.validateForm?.get('taxcodeSection')?.valid) {
          this.calculateTaxcode();
          this.cdr.detectChanges();
        }
      })
    );
  }

  private fillDistrictsTaxCode(): void {
    this.subscriptions.push(
      this.http.getDistrict('IT').subscribe((listDistrict: Array<{ description: string; code: string }>) => {
        this.districtsTaxcode = listDistrict.map((item: { description: string; code: string }) => ({
          value: item.code,
          text: item.description,
        }));
      })
    );
    this.validateForm
      ?.get('taxcodeSection.birthDistrict')
      ?.valueChanges.pipe(
        switchMap((districtChoosed: { value: string; text: string | number | null }) => {
          this.validateForm?.get('taxcodeSection.birthCity')?.patchValue('');
          this.validateForm?.get('taxcodeSection.birthCity')?.updateValueAndValidity();
          this.citiesTaxcode = [];
          return this.http.getProvince(districtChoosed.value);
        })
      )
      .subscribe((listProvince: Array<{ description: string; code: string }>) => {
        this.citiesTaxcode = listProvince.map((item: { description: string; code: string }) => ({
          value: item.code,
          text: item.description,
        }));
        this.cdr.detectChanges();
      });
  }

  //TODO: CHECK IF THAT WORKS
  public checkDisabledState(current: number): boolean {
    switch (current) {
      case 0:
        return this.validateForm.get('name') && this.validateForm.get('surname') ? this.validateForm.get('name')!.invalid || this.validateForm.get('surname')!.invalid : true;
      case 1:
        return this.validateForm.get('fiscalCode') ? this.validateForm.get('fiscalCode')!.invalid : true;
      case 2:
        return this.validateForm.get('email') && this.validateForm.get('phoneNumber')
          ? this.validateForm.get('email')!.invalid || this.validateForm.get('phoneNumber')!.invalid
          : true;
      case 3:
        return ((this.validateForm.getRawValue()?.nation && this.validateForm.getRawValue()?.province && this.validateForm.getRawValue()?.city) ||
          (this.validateForm.get('nation') && this.validateForm.get('province') && this.validateForm.get('city'))) &&
          this.validateForm.get('cap') &&
          this.validateForm.get('address') &&
          this.validateForm.get('houseNumber')
          ? this.validateForm.get('nation')!.invalid ||
              this.validateForm.get('province')!.invalid ||
              this.validateForm.get('city')!.invalid ||
              this.validateForm.get('cap')!.invalid ||
              this.validateForm.get('address')!.invalid ||
              this.validateForm.get('houseNumber')!.invalid
          : true;
      case 4:
        return this.validateForm.get('radio1') && this.validateForm.get('radio2') && this.validateForm.get('radio3') && this.validateForm.get('radio4')
          ? this.validateForm.get('radio1')!.invalid ||
              this.validateForm.get('radio2')!.invalid ||
              this.validateForm.get('radio3')!.invalid ||
              this.validateForm.get('radio4')!.invalid
          : true;
      case 5:
        return this.validateForm.get('radioTerms') ? this.validateForm.get('radioTerms')!.invalid : true;
      default:
        return true;
    }
  }

  private updateUser() {
    if (this.userDataToBeUpdated) {
      if (this.userDataToBeUpdated.name) {
        this.validateForm.get('name')?.patchValue(this.userDataToBeUpdated?.name);
        this.readonlyFields['name'] = true;
      }
      if (this.userDataToBeUpdated.surname) {
        this.validateForm.get('surname')?.patchValue(this.userDataToBeUpdated?.surname);
        this.readonlyFields['surname'] = true;
      }
      if (this.userDataToBeUpdated.email) {
        this.validateForm.get('email')?.patchValue(this.userDataToBeUpdated.email);
        this.readonlyFields['email'] = true;
      }
      if (this.userDataToBeUpdated.phoneNumber) {
        this.validateForm.get('phoneNumber')?.patchValue(this.userDataToBeUpdated.phoneNumber);
        this.readonlyFields['phoneNumber'] = true;
      }
      if (this.userDataToBeUpdated.taxId) {
        this.validateForm.get('fiscalCode')?.patchValue(this.userDataToBeUpdated.taxId);
        this.readonlyFields['fiscalCode'] = true;
        this.validateForm.get('calculateTaxcode')?.disable();
      }
      if (this.userDataToBeUpdated.country) {
        this.http.getCountries().subscribe((a) => {
          this.countries = a;
          this.validateForm.get('nation')?.patchValue(this.countries.find((res: any) => res.description === this.userDataToBeUpdated.country).code);
          this.readonlyFields['nation'] = true;
          this.validateForm.get('nation')?.disable();
          this.http.getDistrict(this.validateForm.get('nation')?.value).subscribe((v: any) => {
            this.districts = v;
            if (this.userDataToBeUpdated.district) {
              this.validateForm.get('province')?.patchValue(this.districts.find((res: any) => res.description === this.userDataToBeUpdated.district).code);
              this.readonlyFields['province'] = true;
              this.validateForm.get('province')?.disable();
              this.http.getProvince(this.validateForm.get('province')?.value).subscribe((c) => {
                this.cities = c;
                if (this.userDataToBeUpdated.city) {
                  this.validateForm.get('city')?.patchValue(this.cities.find((res: any) => res.description === this.userDataToBeUpdated.city).code);
                  this.validateForm.get('city')?.disable();

                  this.readonlyFields['city'] = true;
                }
              });
            }
          });
        });
      }
      if (this.userDataToBeUpdated.postalCode) {
        this.validateForm.get('cap')?.patchValue(this.userDataToBeUpdated.postalCode);
        this.readonlyFields['cap'] = true;
      }
      if (this.userDataToBeUpdated.address) {
        if (this.userDataToBeUpdated.address.includes(',')) {
          const [address, addressNumber] = this.userDataToBeUpdated?.address?.split(',')?.map((s) => s.trim());
          this.validateForm.get('address')?.patchValue(address);
          this.readonlyFields['address'] = true;
          this.validateForm.get('houseNumber')?.patchValue(addressNumber);
          this.readonlyFields['houseNumber'] = true;
        } else {
          this.validateForm.get('address')?.patchValue(this.userDataToBeUpdated?.address);
          this.readonlyFields['address'] = true;
        }
      }
    }
  }
}
